import { ReduxState } from '../server';
import { SET_ACTIVE_PAGE, SET_REPORT_AVAILABLE } from './actions';

function apps(state: ReduxState, action: any): ReduxState {
	switch (action.type) {
		case SET_ACTIVE_PAGE:
			return Object.assign({}, state, {
				activePage: action.activePage,
			});
		case SET_REPORT_AVAILABLE:
			return Object.assign({}, state, {
				reportAvailable: action.reportAvailable,
			});
		default:
			return state;
	}
}
export default apps;
